import ManageSubscriptionModal from 'components/GlobalModals/ManageSubscriptionModal/ManageSubscriptionModal';

export default ManageSubscriptionModal;
